<template>
<div id="cancellation-policies" :class="{'pa-2 ma-2': $vuetify.breakpoint.smAndUp}">
    <im-header @add="addPolicy()" :loading="loading">
        <template v-slot:title>
            <span slot="title"> {{ $t('cancellation_policies.title') }}</span>
        </template>
        <template v-slot:button-name>
            <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('cancellation_policies.button.add_new') }}</span>
            <span v-else>{{ $t('cancellation_policies.button.add_new_short') }}</span>
        </template>
    </im-header>

    <v-container fluid class="px-0">
        <v-row v-if="items.length > 0" class="im-card-items" no-gutters>
            <template v-for="item in items">
                <v-col md="3" sm="6" cols="12" class="pa-2">
                    <im-policy-card class="im-card" :item="item" :currency="hotel.currency" @click="editPolicy(item)" />
                </v-col>
            </template>
        </v-row>
        <div v-else>
            <div v-if="!loading" class="pa-3 important text-center">
                {{$t('cancellation_policies.table_no_data_message')}}
            </div>
        </div>
    </v-container>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import defaults from '../../components/utils/PropDefaults.js';
import IMHeader from '../../components/utils/IMHeader.vue';
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMPolicyCard from "../../components/items/PolicyCardv2.vue";

export default {
    props: ['hotel'],
    name: `cancellation-policiy`,

    components: {
        'im-header': IMHeader,
        'im-table-header': IMTableHeader,
        "im-policy-card": IMPolicyCard,
    },

    data() {
        return {
            loading: null,
            items: [],
        };
    },

    watch: {
        '$route.params': {
            async handler() {
                await this.hotel
                // react to route changes...
                if(this.$route.params.hotel_slug !== this.hotel.slug) {
                    await this.checkSlug(this.$route.params.hotel_slug);
                } else {
                    this.getItems();
                }
            },
            deep: true,
            immediate: true
        },
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        checkSlug(slug) {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/check-slug";
            let params = {
                params: {
                    slug: slug
                }
            };

            return this.$axios.get(endpoint, params)
                .then(response => {
                    if(response.data.exists) {
                        if(JSON.parse(localStorage.getItem('hotel'))
                            .id != response.data.hotel_id) {
                            this.$emit('changeHotel', [response.data.hotel_id, false]);
                        }
                    } else {
                        this.error("Oops, something went wrong!");
                        this.$router.push({
                            path: '/dashboard',
                        });
                    }
                    return new Promise(function (resolve, reject) {
                        resolve(true);
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.error("Oops, something went wrong!");
                })
        },

        getItems() {
            if(!this.hotel.id) {
                return;
            }
            // we are currently loading
            this.loading = true;

            // prepare stamp & save current_stamp
            let stamp = Date.now();

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/cancellation-policies";

            // setup query params
            let params = {
                params: {
                    hotel_id: this.hotel.id,
                    stamp: stamp,
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        editPolicy(policy) {
            defaults.policy_name = policy.name;
            this.$router.push({
                path: '/' + this.hotel.slug + '/cancellation-policies/' + policy.id
            });
        },

        addPolicy() {
            this.$router.push({
                path: '/' + this.hotel.slug + '/cancellation-policies/create'
            });
        },

    }
};
</script>
